import { Component } from '@angular/core';

@Component({
	selector: 'app-css-spinner',
	templateUrl: './css-spinner.component.html',
	styleUrls: ['./css-spinner.component.scss'],
})
export class CssSpinnerComponent {}
